import { api as e } from "../utils/configuration.js";
import { crudService as r } from "../js/request-DH6Y2P3c.js";
const i = {
  create: (t) => r.post(t, e.LEADS_URL),
  deactivate: (t) => r.post(void 0, `${e.LEADS_URL}/deactivate`, {
    headers: { Authorization: `Bearer ${t}` }
  }),
  registerShowingAttempt: (t) => r.post({}, `${e.LEADS_URL}/showing-attempt`, { params: { unitId: t } })
};
export {
  i as LeadService
};
//# sourceMappingURL=lead.js.map
